import * as React from 'react';
import * as _ from 'underscore';
import * as $ from 'jquery';

import StringField from '../../../../_common/platform/tsx/StringField';

export default function VariableField(props: { value?: string; onChange?(value: string): void }) {
    return (
        <div className="variable-field">
            <table>
                <tbody>
                    <tr>
                        <td className="cell-variable-mark border-0">{'@'}</td>

                        <td className="cell-variable-name border-0">
                            <StringField value={props.value} onChange={props.onChange} />
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
}
